import { MarkerClusterer, GridAlgorithm } from '@googlemaps/markerclusterer';

import '../sass/course-list.scss';

const iconPath = 'M15.9297 0.75C20.1068 0.75 24.1127 2.40958 27.0664 5.36328C30.0201 8.31698 31.6797 12.3228 31.6797 16.5C31.6797 28.75 15.9297 39.25 15.9297 39.25C15.9297 39.25 0.179688 28.75 0.179688 16.5C0.179688 12.3228 1.83927 8.31698 4.79297 5.36328C7.74667 2.40958 11.7525 0.75 15.9297 0.75ZM15.9297 11.25C13.0302 11.25 10.6797 13.6005 10.6797 16.5C10.6797 19.3995 13.0302 21.75 15.9297 21.75C18.8292 21.75 21.1797 19.3995 21.1797 16.5C21.1797 13.6005 18.8292 11.25 15.9297 11.25Z';

const redIcon = {
    path: iconPath,
    fillColor: '#E93E43',
    fillOpacity: 1,
    strokeWeight: 0,
    rotation: 0,
    anchor: new google.maps.Point(15.75, 38.5),
};

(() => {
    const $blocks = document.querySelectorAll('.course-list');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $filterDropdown = $block.querySelector('.course-list__filter-dropdown');
        const $filterForms = $block.querySelectorAll('.course-list__filter-form');
        const $map = $block.querySelector('.course-list__map');
        const $tableBody = $block.querySelector('.course-list__table-body');

        let map, mapMarkers, markerCluster, inputTimeout;

        const initFilterDropdown = () => {
            if (!$filterDropdown) return;

            new Details($filterDropdown);
        };

        const initFilterForms = () => {
            if (!$filterForms) return;

            $filterForms.forEach($form => {
                const $search = $form.querySelector('[name="search"]');
                const $area = $form.querySelector('[name="area"]');

                $form.addEventListener('submit', e => {
                    e.preventDefault();

                    filterCourses({
                        search: $search?.value,
                        area: $area?.value
                    });
                });

                $search.addEventListener('keyup', () => {
                    if (inputTimeout) { 
                        clearTimeout(inputTimeout);
                    }

                    inputTimeout = setTimeout(() => {
                        filterCourses({
                            search: $search?.value,
                            area: $area?.value
                        });
                    }, 500);
                });

                $area.addEventListener('change', () => {
                    filterCourses({
                        search: $search?.value,
                        area: $area?.value
                    });
                });
            });
        };

        const initMap = () => {
            if (map) return;

            map = new google.maps.Map($map, {
                center: {
                    lat: 54.75,
                    lng: -3.25,
                },
                zoom: window.innerWidth >= 1024 ? 6 : 5,
                disableDefaultUI: true,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.TOP_RIGHT,
                }
            });
        };

        const setMapMarkers = ({
            area = null,
        } = {}) => {
            if (!map) return;

            if (mapMarkers) {
                mapMarkers.forEach(marker => {
                    marker.setMap(null);
                });
            }

            mapMarkers = [];

            if (markerCluster) {
                markerCluster.setMap(null);
            }
            
            const infoWindow = new google.maps.InfoWindow({
                content: '',
                maxWidth: 375,
                disableAutoPan: false,
            });

            const $courses = $block.querySelectorAll('.course-list__course');

            if ($courses) {
                $courses.forEach($course => {
                    const {
                        title,
                        link,
                        image,
                        lat,
                        lng,
                        areaLabel,
                        fixtureLabel,
                        fixtureTitle,
                        fixtureLink,
                        fixtureDate,
                        fixtureTicketsUrl,
                        fixtureTicketsLabel,
                    } = $course.dataset;

                    const courseArea = $course?.dataset?.area?.split(',');

                    if (area && !courseArea?.includes(area)) return;

                    const markerLat = lat ? parseFloat(lat) : null;
                    const markerLng = lng ? parseFloat(lng) : null;

                    if (!markerLat || !markerLng || isNaN(markerLat) || isNaN(markerLng)) return;

                    const position = new google.maps.LatLng(parseFloat(lat), parseFloat(lng));

                    const marker = new google.maps.Marker({
                        position,
                        icon : redIcon
                    });

                    marker.addListener('click', () => {
                        infoWindow.setContent(`
                            <div class="course-list__map-card background-color-white">
                                ${image ? `
                                    <div class="course-list__map-card-image">
                                        <img src="${image}" alt="${title}" />
                                    </div>
                                ` : ''}

                                <div class="course-list__map-card-content">
                                    <div class="course-list__map-card-course">
                                        ${link ? `<a href="${link}">` : ''}
                                            ${title ? `<span class="caps">${title}</span>` : ''}
                                        ${link ? '</a>' : ''}

                                        ${areaLabel ? `<div>${areaLabel}</div>` : ''}
                                    </div>

                                    ${fixtureTitle || fixtureLink || fixtureDate || fixtureTicketsUrl ? `
                                        <div class="course-list__map-card-fixture">
                                            <div class="course-list__map-card-fixture-details">
                                                ${fixtureLabel ? `<div class="caps caps--small">${fixtureLabel}</div>` : ''}

                                                ${fixtureDate ? `<div class="body-large semi-bold">${fixtureDate}</div>` : ''}

                                                ${fixtureLink ? `<a href="${fixtureLink}">` : ''}
                                                    ${fixtureTitle}
                                                ${fixtureLink ? '</a>' : ''}
                                            </div>

                                            ${fixtureTicketsUrl ? `
                                                <a class="btn btn--outline" 
                                                    href="${fixtureTicketsUrl}"
                                                    target="_blank"
                                                    rel="noopener noreferrer">

                                                    ${fixtureTicketsLabel}
                                                </a>
                                            ` : ''}
                                        </div>
                                    ` : ''}
                                </div>
                            </div>
                        `);

                        infoWindow.open({
                            anchor: marker,
                            map
                        });
                    });

                    mapMarkers.push(marker);
                });

                markerCluster = new MarkerClusterer({
                    markers: mapMarkers, 
                    map,
                    onClusterClick: (e, cluster) => {
                        infoWindow.close();
                        map.fitBounds(cluster.bounds);

                        return true;
                    },
                    algorithm: new GridAlgorithm({ 
                        maxDistance: 40000,
                        gridSize: 50
                    }),
                    renderer: {
                        render: function ({ count, position }, stats) {
                            const svg = window.btoa(`
                                <svg fill="#383838" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <circle cx="12" cy="12" r="12" />    
                                </svg>`);
                                
                            return new google.maps.Marker({
                                position,
                                icon: {
                                    url: `data:image/svg+xml;base64,${svg}`,
                                    scaledSize: new google.maps.Size(64, 64),
                                },
                                label: {
                                    text: String(count),
                                    color: '#fff',
                                    fontSize: '20px',
                                    fontFamily: "'Gilroy', sans-serif",
                                    fontWeight: 'bold'
                                },
                                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                            });
                        },
                    },
                });

                google.maps.event.addListener(map, 'click', () => {
                    infoWindow.close();
                });
            }

            setMapBounds();
        };

        const setMapBounds = () => {
            const bounds = new google.maps.LatLngBounds();

            mapMarkers.forEach(marker => {
                bounds.extend(marker.position);
            });

            map.fitBounds(bounds);

            // Don't zoom in too far on only one marker
            if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
               const extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
               const extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
               
               bounds.extend(extendPoint1);
               bounds.extend(extendPoint2);
            }

            map.fitBounds(bounds);
        }

        const filterCourses = ({
            search,
            area
        }) => {
            const historyParams = new URLSearchParams();

            const $courses = $block.querySelectorAll('.course-list__course');

            if (search) {
                historyParams.set('search', search);

                const geocoder = new google.maps.Geocoder();

                geocoder.geocode({ address: search }, (results, status) => {
                    if (status === 'OK') {
                        const searchLat = results[0].geometry.location.lat();
                        const searchLng = results[0].geometry.location.lng();

                        const reorder = [...$courses].sort((a, b) => {
                            return parseFloat(getDistance(searchLat, searchLng, a.dataset.lat, a.dataset.lng)) - parseFloat(getDistance(searchLat, searchLng, b.dataset.lat, b.dataset.lng));
                        });

                        $tableBody.innerHTML = '';

                        reorder.forEach($course => {
                            $tableBody.appendChild($course);
                        });
                    }
                });
            } else {
                const reorder = [...$courses].sort((a, b) => {
                    if (a.dataset.title < b.dataset.title) {
                        return -1;
                    }
                    if (a.dataset.title > b.dataset.title) {
                        return 1;
                    }
                    return 0;
                });

                $tableBody.innerHTML = '';

                reorder.forEach($course => {
                    $tableBody.appendChild($course);
                });
            }

            if (area) {
                historyParams.set('area', area);
            }

            history.replaceState(null, null, '?' + historyParams.toString());

            $filterForms.forEach($form => {
                const $search = $form.querySelector('[name="search"]');
                const $area = $form.querySelector('[name="area"]');

                if (search) {
                    $search.value = search;
                }

                if (area) {
                    $area.value = area;
                }
            });

            setMapMarkers({
                search,
                area
            });

            if ($courses) {
                $courses.forEach($course => {
                    const courseArea = $course?.dataset?.area?.split(',');

                    if (!area || courseArea?.includes(area)) {
                        $course.classList.remove('course-list__course--hide');
                    } else {
                        $course.classList.add('course-list__course--hide');
                    }
                });
            }
        };

        const getDistance = (lat1, lng1, lat2, lng2, unit) => {
            const radlat1 = Math.PI * lat1/180
            const radlat2 = Math.PI * lat2/180
            const theta = lng1-lng2
            const radtheta = Math.PI * theta/180
            let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist)
            dist = dist * 180/Math.PI
            dist = dist * 60 * 1.1515
            if (unit=="K") { dist = dist * 1.609344 }
            if (unit=="N") { dist = dist * 0.8684 }
            return dist
        }

        const initCourseList = () => {
            fetch('/wp-json/point-to-point/courses', {
                method: 'GET',
            }).then(async response => {
                if (!response.ok) {
                    throw new Error(`Response status: ${response.status}`);
                }

                const json = await response.json();
            
                return json;
            }).then(json => {
                if (json.courses_html) {
                    $tableBody.innerHTML = json.courses_html;

                    initFilterDropdown();
                    initFilterForms();
                    initMap();

                    const params = new URLSearchParams(document.location.search);

                    setMapMarkers({
                        area: params.get('area'),
                    });

                    if (params.get('search') || params.get('area')) {
                        filterCourses({
                            search: params.get('search'),
                            area: params.get('area'),
                        });
                    }
                }
            }).catch(error => {
            });
        }

        initCourseList();
        initMap();
    });
})();
